
export function register(config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      console.log(" [SW] Register process started:", swUrl);
      navigator.serviceWorker.register(swUrl).then(registration => {
         console.log(" [SW] Registered successfully:", registration);
        registration.onupdatefound = () => {
          console.log("SW] Update found, installing new worker...");

          const installingWorker = registration.installing;
          if (installingWorker == null) return;

          installingWorker.onstatechange = () => {
            console.log("[SW] State changed:", installingWorker.state);
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                console.log("[SW] State changed:", installingWorker.state);
                config?.onUpdate?.(registration);
              } else {
                config?.onSuccess?.(registration);
              }
            }
          };
        };
      }).catch(error => {
        console.error('Error during service worker registration:', error);
        console.log('catch+++++++++++++++++++++')
      });
    });
  }
}
